import { render, staticRenderFns } from "./CreateNewPassword.vue?vue&type=template&id=c224497e&scoped=true"
import script from "./CreateNewPassword.vue?vue&type=script&lang=ts"
export * from "./CreateNewPassword.vue?vue&type=script&lang=ts"
import style0 from "./CreateNewPassword.vue?vue&type=style&index=0&id=c224497e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c224497e",
  null
  
)

export default component.exports